import { motion } from "framer-motion";
import { Eyebrow, Reveal } from "@/components/primitives";
import { HIDDEN_COSTS } from "@/data/content";
import { cn } from "@/lib/utils";

const SPANS = [
    "md:col-span-2",
    "md:col-span-1",
    "md:col-span-1",
    "md:col-span-1",
    "md:col-span-1",
];

export default function HiddenCost() {
    return (
        <section className="border-t border-border py-24 md:py-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-10">
                <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
                    <div className="lg:col-span-8">
                        <Reveal>
                            <Eyebrow>The Hidden Cost of Manual Operations</Eyebrow>
                        </Reveal>
                        <Reveal delay={0.05}>
                            <h2 className="mt-5 max-w-3xl text-balance text-4xl font-bold leading-[1.1] tracking-tight md:text-5xl">
                                Every shipping company has hidden operational
                                bottlenecks
                            </h2>
                        </Reveal>
                    </div>
                    <div className="lg:col-span-4">
                        <Reveal delay={0.1}>
                            <p className="text-lg leading-relaxed text-muted-foreground">
                                Operational teams spend thousands of hours every
                                year performing repetitive work that AI can
                                automate.
                            </p>
                        </Reveal>
                    </div>
                </div>

                <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-3">
                    {HIDDEN_COSTS.map((c, i) => (
                        <Reveal key={c.title} delay={i * 0.06} className={SPANS[i]}>
                            <motion.article
                                whileHover={{ y: -6 }}
                                transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                                className={cn(
                                    "group relative flex h-full min-h-[220px] flex-col justify-between overflow-hidden rounded-3xl border border-border bg-card p-8 transition-colors duration-300 hover:border-foreground/25",
                                    i === 0 && "md:min-h-[220px]",
                                )}
                            >
                                <div className="flex items-baseline justify-between">
                                    <h3 className="text-xl font-semibold tracking-tight">
                                        {c.title}
                                    </h3>
                                    <span className="font-mono text-2xl font-medium text-navy">
                                        {c.metric}
                                    </span>
                                </div>
                                <p className="mt-4 max-w-md text-[15px] leading-relaxed text-muted-foreground">
                                    {c.body}
                                </p>
                                <div className="mt-6 overflow-hidden">
                                    <span className="block font-mono text-xs uppercase tracking-[0.16em] text-muted-foreground/70 transition-transform duration-300 ease-premium group-hover:-translate-y-0 group-hover:text-navy">
                                        {c.metricLabel}
                                    </span>
                                </div>
                            </motion.article>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
